import useOnly from "./useOnly.js";
export const useCurrentBreakpoint = ()=>{
    const xs = useOnly('xs');
    const sm = useOnly('sm');
    const md = useOnly('md');
    const lg = useOnly('lg');
    const tablet = useOnly('tablet');
    const xl = useOnly('xl');
    const twoxl = useOnly('2xl');
    const xxl = useOnly('xxl');
    const breakPoints = [
        {
            breakpoint: 'xs',
            isActive: xs
        },
        {
            breakpoint: 'sm',
            isActive: sm
        },
        {
            breakpoint: 'md',
            isActive: md
        },
        {
            breakpoint: 'lg',
            isActive: lg
        },
        {
            breakpoint: 'tablet',
            isActive: tablet
        },
        {
            breakpoint: 'xl',
            isActive: xl
        },
        {
            breakpoint: '2xl',
            isActive: twoxl
        },
        {
            breakpoint: 'xxl',
            isActive: xxl
        }
    ];
    return breakPoints.find((x)=>x.isActive)?.breakpoint ?? 'xxl';
};
export default useCurrentBreakpoint;

//# sourceMappingURL=useCurrentBreakpoint.js.map